/*
 * ENOVA PRECHECKOUT - Adaptado para Cart Drawer
 * Migrado desde la página de carrito al drawer lateral
 */

/* ============================================
   INICIALIZACIÓN DEL DRAWER (REEMPLAZA setInterval)
   ============================================ */

var _enovaFormListenersSet = false;

function initDrawerStep2() {
  initSetFormDataUbigeosAvailable();
  setInitCustomerData();

  getResponseCartItems(true)
    .then(function(carritoItemsListE) {
      if (!isCarritoProductTypeShipping(carritoItemsListE)) {
        jQuery('.enova-carrito-block-seleccion-despacho').hide();
        jQuery('#despacho-title').hide();
        jQuery('.enova-carrito-block-despacho-shipping__title').text('Ingrese su dirección de facturación');
        jQuery('.enova-carrito-block-seleccion-despacho__container #enova-despacho-delivery-option').parent().trigger('click');
        jQuery('.enova-carrito-block-despacho-shipping-tipo__delivery').removeClass('active');
      } else {
        if (!document.querySelector('input[name=enova-despacho]:checked')) {
          var deliveryRadio = document.querySelector('#enova-despacho-delivery-option');
          if (deliveryRadio) {
            deliveryRadio.checked = true;
            document.querySelectorAll('.enova-despacho-selector-item').forEach(function(el) {
              el.classList.remove('active');
            });
            var parentLabel = deliveryRadio.closest('.enova-despacho-selector-item');
            if (parentLabel) parentLabel.classList.add('active');
            jQuery('#enova-despacho-shipping').css('display', 'block');
            jQuery('#enova-despacho-recojo-tienda').css('display', 'none');
          }
        }
      }
    })
    .catch(function(err) {
      console.error('Error al verificar productos del carrito', err);
    });
}

function setupPrecheckoutFormListeners() {
  if (_enovaFormListenersSet) return;
  _enovaFormListenersSet = true;

  /* -------------------------------------------------------
     Un solo listener de CLICK delegado en document.
     Sobrevive cualquier reemplazo de DOM por renderContents.
  ------------------------------------------------------- */
  document.addEventListener('click', function(e) {

    // Botón "Siguiente" (paso 1 → paso 2)
    if (e.target.closest('#CartDrawer-SiguienteBtn')) {
      e.preventDefault();
      showDrawerStep2();
      return;
    }

    // Botón "Atrás" (paso 2 → paso 1)
    if (e.target.closest('#CartDrawer-BackBtn')) {
      e.preventDefault();
      showDrawerStep1();
      return;
    }

    // Botón "Finalizar pedido"
    if (e.target.closest('#enova_cart-data-submit')) {
      handlePrecheckoutSubmit(e);
      return;
    }

    // Radio: tipo de despacho (delivery / recojo-tienda)
    var despachoItem = e.target.closest('.enova-despacho-selector-item');
    if (despachoItem) {
      var radio = despachoItem.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      document.querySelectorAll('.enova-despacho-selector-item').forEach(function(el) { el.classList.remove('active'); });
      despachoItem.classList.add('active');
      if (radio.value === 'recojo-tienda') {
        jQuery('#enova-despacho-shipping').css('display', 'none');
        jQuery('#enova-despacho-recojo-tienda').css('display', 'block');
        var selFecha = document.querySelector('#enova-despacho-delivery-select-fecha');
        if (selFecha) selFecha.value = null;
        var firstTipo = document.querySelector('input[name=enova-despacho-tipo]:first-child');
        if (firstTipo) firstTipo.checked = true;
      } else if (radio.value === 'delivery') {
        jQuery('#enova-despacho-shipping').css('display', 'block');
        jQuery('#enova-despacho-recojo-tienda').css('display', 'none');
        var fechaRecojo = document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha');
        if (fechaRecojo) fechaRecojo.classList.remove('active');
        var selRecojoFecha = document.querySelector('#enova-despacho-recojo-tienda-select-fecha');
        if (selRecojoFecha) selRecojoFecha.value = null;
      }
      return;
    }

    // Radio: boleta / factura
    var billingItem = e.target.closest('.enova-billing-item');
    if (billingItem) {
      var radio = billingItem.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      document.querySelectorAll('.enova-billing-item').forEach(function(el) { el.classList.remove('active'); });
      billingItem.classList.add('active');
      var billingDocEl = document.querySelector('#enova-billing-doc');
      if (radio.value === 'factura') {
        if (billingDocEl) { billingDocEl.classList.add('active'); billingDocEl.classList.remove('disabled'); billingDocEl.style.display = ''; }
        var despChecked = document.querySelector('input[name=enova-despacho]:checked');
        if (despChecked && despChecked.value === 'recojo-tienda') {
          jQuery('#formulario--billing-address_checkbox').prop('checked', false);
          jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'block');
          jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox').css('display', 'none');
        }
      } else if (radio.value === 'boleta') {
        if (billingDocEl) { billingDocEl.classList.remove('active'); billingDocEl.classList.add('disabled'); billingDocEl.style.display = ''; }
        jQuery('#formulario--billing-address_checkbox').prop('checked', true);
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'none');
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox').css('display', 'block');
      }
      return;
    }

    // Selección de tienda (recojo en tienda)
    var storeItem = e.target.closest('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--item');
    if (storeItem) {
      var radio = storeItem.querySelector('input[type="radio"]');
      if (!radio) return;
      radio.checked = true;
      document.querySelectorAll('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--item').forEach(function(el) { el.classList.remove('active'); });
      storeItem.classList.add('active');
      var fechaTienda = document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha');
      if (fechaTienda) fechaTienda.classList.add('active');
      var selFechaTienda = document.querySelector('#enova-despacho-recojo-tienda-select-fecha');
      if (selFechaTienda) selFechaTienda.value = null;
      return;
    }
  });

  /* -------------------------------------------------------
     Un solo listener de CHANGE delegado en document
  ------------------------------------------------------- */
  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.matches) return;

    // Distrito → calcula métodos de envío disponibles
    if (e.target.matches('#enova-carrito-block-despacho-shipping__distrito')) {
      jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'none');
      despachoMethodShippingLoading('loading');
      var selectDistrito = e.target;
      if (selectDistrito.value && selectDistrito.value !== '0' && selectDistrito.value !== 'Seleccione...') {
        getResponseCartItems(true)
          .then(function(carritoItemsListE) {
            if (!isCarritoProductTypeShipping(carritoItemsListE)) {
              despachoMethodShippingLoading(null);
              jQuery('.enova-carrito-block-despacho-shipping-tipo__delivery').removeClass('active');
              jQuery('#enova-despacho-enova-despacho-servicio-option').attr('checked', true);
            } else {
              despachoMethodShippingLoading('loading');
              var SelectedDepartamentoUBIGEO = jQuery('#enova-carrito-block-despacho-shipping__distrito option:selected').data('ubigeo');
              var carrito_productos = carritoItemsListE.map(function(el_producto) {
                var selectedAttr_peso = el_producto.attributes.find(function(item_key) { return item_key.key === 'peso'; });
                var selectedAttr_sku  = el_producto.attributes.find(function(item_key) { return item_key.key === 'sku'; });
                return {
                  sku: selectedAttr_sku ? selectedAttr_sku.value : '',
                  quantity: el_producto.quantity,
                  volumen_unit: null,
                  weight_unit: selectedAttr_peso && selectedAttr_peso.value ? parseFloat(selectedAttr_peso.value) : 0,
                  position: null
                };
              });
              var productCart = JSON.stringify(carrito_productos);
              var urlBuilder = '?scope=district-calc-rates&ubigeo=' + SelectedDepartamentoUBIGEO + '&products=' + productCart;
              if (SelectedDepartamentoUBIGEO) {
                fetch(window.Shopify.routes.root + 'apps/apolo-ubigeo-calculation' + urlBuilder, {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                })
                .then(function(res) { return res.json(); })
                .then(function(response) {
                  SetRenderShippingMethodsListOption(response);
                  if (getCustomerData('shippingMethodType')) {
                    var shippingMethodType = getCustomerData('shippingMethodType');
                    jQuery('input[name="enova-despacho-tipo"][value="' + shippingMethodType + '"]').prop('checked', true).trigger('change');
                    if (shippingMethodType === 'programmed' &&
                        shippingMethodType === jQuery('input[name="enova-despacho-tipo"]:checked').val()) {
                      jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'flex');
                    }
                  }
                  despachoMethodShippingLoading(null);
                })
                .catch(function(error) {
                  console.error('Error al calcular envío:', error);
                  despachoMethodShippingLoading(null);
                });
              } else {
                alert('Debe seleccionar un Distrito Válido');
              }
            }
          })
          .catch(function(err) {
            console.error(err);
            despachoMethodShippingLoading(null);
          });
      } else {
        despachoMethodShippingLoading(null);
      }
      return;
    }

    // Tipo de envío (express / programado)
    if (e.target.matches('input[name=enova-despacho-tipo]') && e.target.checked) {
      var fechaEl = document.querySelector('.enova-carrito-block-despacho-shipping__fecha');
      if (fechaEl) fechaEl.classList.remove('active');
      jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'none');
      if (e.target.value === 'programmed') {
        if (fechaEl) fechaEl.classList.add('active');
        jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'flex');
        setLogistictProgrammedDateRules();
      }
      return;
    }

    // Tipo de documento de identidad
    if (e.target.matches('#enova-billing-documento-type')) {
      jQuery('#enova-billing-documento-number').val('');
      jQuery('p.text-has-error.text-typedoc').remove();
      var docNumEl = document.querySelector('#enova-billing-documento-number');
      if (docNumEl) docNumEl.classList.remove('input-has-error');
      return;
    }

    // Checkbox "usar misma dirección para facturación"
    if (e.target.matches('#formulario--billing-address_checkbox')) {
      if (!e.target.checked) {
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'block');
      } else {
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'none');
      }
      return;
    }
  });

  /* -------------------------------------------------------
     Un solo listener de KEYPRESS delegado en document
  ------------------------------------------------------- */
  document.addEventListener('keypress', function(e) {
    if (!e.target || !e.target.matches) return;

    if (e.target.matches('#enova-billing-documento-number')) {
      var docType = document.querySelector('#enova-billing-documento-type') ? document.querySelector('#enova-billing-documento-type').value : '';
      var currentLength = e.target.value.length;
      var regex;
      if      (docType === '1') { regex = /^[0-9]$/;      if (currentLength >= 8)  { e.preventDefault(); return; } }
      else if (docType === '2') { regex = /^[a-zA-Z0-9]$/; if (currentLength >= 12) { e.preventDefault(); return; } }
      else if (docType === '3') { regex = /^[0-9]$/;      if (currentLength >= 11) { e.preventDefault(); return; } }
      else { return; }
      if (!regex.test(e.key)) e.preventDefault();
      return;
    }

    if (e.target.matches('#enova-billing-telefono')) {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
      return;
    }

    if (e.target.matches('#enova-billing-doc-ruc')) {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
      return;
    }
  });
}

function showDrawerStep2() {
  var step1 = document.getElementById('CartDrawer-Step1');
  var step2 = document.getElementById('CartDrawer-Step2');
  if (!step1 || !step2) return;

  step1.classList.add('cart-drawer__step--hidden');
  step2.classList.remove('cart-drawer__step--hidden');

  initDrawerStep2();
}

function showDrawerStep1() {
  var step1 = document.getElementById('CartDrawer-Step1');
  var step2 = document.getElementById('CartDrawer-Step2');
  if (!step1 || !step2) return;

  step2.classList.add('cart-drawer__step--hidden');
  step1.classList.remove('cart-drawer__step--hidden');
}

/* ============================================
   INICIALIZACIÓN GLOBAL
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  setupPrecheckoutFormListeners();
  setLogistictProgrammedDateRules();
});

/* ============================================
   EVENTOS DE FORMULARIO
   ============================================ */

function setFormDespacho() {
  document.querySelectorAll('.enova-despacho-selector-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var radio = item.querySelector('input[type="radio"]');
      if (!radio) return;

      radio.checked = true;

      document.querySelectorAll('.enova-despacho-selector-item').forEach(function(el) {
        el.classList.remove('active');
      });
      item.classList.add('active');

      if (radio.value === 'recojo-tienda') {
        jQuery('#enova-despacho-shipping').css('display', 'none');
        jQuery('#enova-despacho-recojo-tienda').css('display', 'block');

        if (document.querySelector('#enova-despacho-delivery-select-fecha')) {
          document.querySelector('#enova-despacho-delivery-select-fecha').value = null;
        }
        if (document.querySelector('input[name=enova-despacho-tipo]:first-child')) {
          document.querySelector('input[name=enova-despacho-tipo]:first-child').checked = true;
        }

      } else if (radio.value === 'delivery') {
        jQuery('#enova-despacho-shipping').css('display', 'block');
        jQuery('#enova-despacho-recojo-tienda').css('display', 'none');

        if (document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha')) {
          document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha').classList.remove('active');
        }
        if (document.querySelector('#enova-despacho-recojo-tienda-select-fecha')) {
          document.querySelector('#enova-despacho-recojo-tienda-select-fecha').value = null;
        }
      }
    });
  });
}

function setFormBillingDoc() {
  document.querySelectorAll('.enova-billing-item').forEach(function(item) {
    item.addEventListener('click', function() {
      var radio = item.querySelector('input[type="radio"]');
      if (!radio) return;

      radio.checked = true;

      document.querySelectorAll('.enova-billing-item').forEach(function(el) {
        el.classList.remove('active');
      });
      item.classList.add('active');

      var billingDocEl = document.querySelector('#enova-billing-doc');

      if (radio.value === 'factura') {
        if (billingDocEl) {
          billingDocEl.classList.add('active');
          billingDocEl.classList.remove('disabled');
          billingDocEl.style.display = '';
        }

        if (document.querySelector('input[name=enova-despacho]:checked') &&
            document.querySelector('input[name=enova-despacho]:checked').value === 'recojo-tienda') {
          jQuery('#formulario--billing-address_checkbox').prop('checked', false);
          jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'block');
          jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox').css('display', 'none');
        }

      } else if (radio.value === 'boleta') {
        if (billingDocEl) {
          billingDocEl.classList.remove('active');
          billingDocEl.classList.add('disabled');
          billingDocEl.style.display = '';
        }

        jQuery('#formulario--billing-address_checkbox').prop('checked', true);
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_addressform').css('display', 'none');
        jQuery('.enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox').css('display', 'block');
      }
    });
  });
}

function setStoresEventClick() {
  document.querySelectorAll('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--item').forEach(function(item) {
    item.addEventListener('click', function() {
      var radio = item.querySelector('input[type="radio"]');
      if (!radio) return;

      radio.checked = true;

      document.querySelectorAll('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--item').forEach(function(el) {
        el.classList.remove('active');
      });
      item.classList.add('active');

      if (document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha')) {
        document.querySelector('.enova-carrito-block-despacho-recojo-tienda__fecha').classList.add('active');
      }
      if (document.querySelector('#enova-despacho-recojo-tienda-select-fecha')) {
        document.querySelector('#enova-despacho-recojo-tienda-select-fecha').value = null;
      }
    });
  });
}

/* ============================================
   CÁLCULO DE ENVÍO POR UBIGEO
   ============================================ */

function calculateShippingMethodByUbigeoSelected() {
  var selectDistrito = document.querySelector('#enova-carrito-block-despacho-shipping__distrito');
  if (!selectDistrito) return;

  selectDistrito.addEventListener('change', function() {
    jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'none');
    despachoMethodShippingLoading('loading');

    if (
      selectDistrito.value &&
      selectDistrito.value !== '0' &&
      selectDistrito.value !== 'Seleccione...'
    ) {
      getResponseCartItems(true)
        .then(function(carritoItemsListE) {
          if (!isCarritoProductTypeShipping(carritoItemsListE)) {
            despachoMethodShippingLoading(null);
            jQuery('.enova-carrito-block-despacho-shipping-tipo__delivery').removeClass('active');
            jQuery('#enova-despacho-enova-despacho-servicio-option').attr('checked', true);
          } else {
            despachoMethodShippingLoading('loading');

            var SelectedDepartamentoUBIGEO = jQuery('#enova-carrito-block-despacho-shipping__distrito option:selected').data('ubigeo');

            var carrito_productos = carritoItemsListE.map(function(el_producto) {
              var selectedAttr_peso = el_producto.attributes.find(function(item_key) { return item_key.key === 'peso'; });
              var selectedAttr_sku  = el_producto.attributes.find(function(item_key) { return item_key.key === 'sku'; });
              return {
                sku: selectedAttr_sku ? selectedAttr_sku.value : '',
                quantity: el_producto.quantity,
                volumen_unit: null,
                weight_unit: selectedAttr_peso && selectedAttr_peso.value ? parseFloat(selectedAttr_peso.value) : 0,
                position: null
              };
            });

            var productCart = JSON.stringify(carrito_productos);
            var urlBuilder = '?scope=district-calc-rates&ubigeo=' + SelectedDepartamentoUBIGEO + '&products=' + productCart;

            if (SelectedDepartamentoUBIGEO) {
              fetch(window.Shopify.routes.root + 'apps/apolo-ubigeo-calculation' + urlBuilder, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
              })
              .then(function(res) { return res.json(); })
              .then(function(response) {
                SetRenderShippingMethodsListOption(response);
                if (getCustomerData('shippingMethodType')) {
                  var shippingMethodType = getCustomerData('shippingMethodType');
                  jQuery('input[name="enova-despacho-tipo"][value="' + shippingMethodType + '"]').prop('checked', true).trigger('change');
                  if (shippingMethodType === 'programmed' &&
                      shippingMethodType === jQuery('input[name="enova-despacho-tipo"]:checked').val()) {
                    jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'flex');
                  }
                }
                despachoMethodShippingLoading(null);
              })
              .catch(function(error) {
                console.error('Error al calcular envío:', error);
                despachoMethodShippingLoading(null);
              });
            } else {
              alert('Debe seleccionar un Distrito Válido');
            }
          }
        })
        .catch(function(err) {
          console.error(err);
          despachoMethodShippingLoading(null);
        });
    } else {
      despachoMethodShippingLoading(null);
    }
  });
}

function despachoMethodShippingLoading(status) {
  var loadingEl = document.querySelector('.enova-despacho-shipping-loading');
  var deliveryEl = document.querySelector('.enova-carrito-block-despacho-shipping-tipo__delivery');
  if (!loadingEl || !deliveryEl) return;

  if (status === 'loading') {
    loadingEl.classList.add('active');
    deliveryEl.classList.remove('active');
    deliveryEl.classList.add('disabled');
  } else {
    loadingEl.classList.remove('active');
    deliveryEl.classList.add('active');
    deliveryEl.classList.remove('disabled');
  }
}

function calculateShippingMethodToShowOption() {
  document.querySelectorAll('input[name=enova-despacho-tipo]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var checked = document.querySelector('input[name=enova-despacho-tipo]:checked');
      if (!checked) return;

      document.querySelector('.enova-carrito-block-despacho-shipping__fecha').classList.remove('active');
      jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'none');

      if (checked.value === 'programmed') {
        document.querySelector('.enova-carrito-block-despacho-shipping__fecha').classList.add('active');
        jQuery('.enova-carrito-block-despacho-shipping__fecha').css('display', 'flex');
        setLogistictProgrammedDateRules();
      }
    });
  });
}

/* ============================================
   REGLAS DE FECHA PROGRAMADA
   ============================================ */

function setLogistictProgrammedDateRules() {
  var inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
  if (!inputFecha) return;

  var hoy = new Date();
  var horaActual = hoy.getHours();
  var horarioCorte = 21;

  var feriados = [
    '30-08-2025', '31-08-2025', '01-11-2025', '02-11-2025', '08-12-2025',
    '09-12-2025', '10-12-2025', '24-12-2025', '25-12-2025', '28-12-2025',
    '01-01-2026', '10-01-2026', '02-04-2026', '03-04-2026', '01-05-2026',
    '02-05-2026', '23-07-2026', '28-07-2026', '29-07-2026'
  ];

  function esFeriado(fecha) {
    var dia  = fecha.getDate().toString().padStart(2, '0');
    var mes  = (fecha.getMonth() + 1).toString().padStart(2, '0');
    var anio = fecha.getFullYear();
    var fechaStr = dia + '-' + mes + '-' + anio;
    if (dia === '05' && mes === '08' && anio === '2025') return false;
    return feriados.includes(fechaStr);
  }

  inputFecha.innerHTML = '';

  var diasAntesDeCorte  = { 1:1, 2:1, 3:1, 4:1, 5:1, 6:2, 0:2 };
  var diasDespuesDeCorte = { 1:2, 2:2, 3:3, 4:2, 5:4, 6:3, 0:2 };
  var diaHoy = hoy.getDay();
  var mapa = horaActual >= horarioCorte ? diasDespuesDeCorte : diasAntesDeCorte;

  var fechaInicio = new Date(hoy);
  fechaInicio.setDate(fechaInicio.getDate() + mapa[diaHoy]);

  var diasValidos = [];
  var temp = new Date(fechaInicio);
  var nombres = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  while (diasValidos.length < 7) {
    var d = temp.getDay();
    if (d !== 0 && !esFeriado(temp)) {
      diasValidos.push({ fecha: formatDateToDDMMYYYY(temp), dia: nombres[d] });
    }
    temp.setDate(temp.getDate() + 1);
  }

  diasValidos.forEach(function(item) {
    var opt = document.createElement('option');
    opt.value = item.fecha;
    opt.textContent = item.dia + ', ' + item.fecha;
    inputFecha.appendChild(opt);
  });

  function formatDateToDDMMYYYY(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return d + '-' + m + '-' + y;
  }
}

/* ============================================
   SUBMIT DEL PRECHECKOUT
   ============================================ */

function checkoutButtonLoader(status) {
  var submitBtn = document.getElementById('enova_cart-data-submit');
  if (!submitBtn) return;
  var textEl = submitBtn.querySelector('.loader-button__text');

  if (status) {
    if (textEl) textEl.textContent = 'Cargando...';
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.style.pointerEvents = 'none';
    submitBtn.style.opacity = '0.6';
  } else {
    if (textEl) textEl.textContent = 'Ir a pagar';
    submitBtn.setAttribute('aria-busy', 'false');
    submitBtn.style.pointerEvents = '';
    submitBtn.style.opacity = '';
  }
}

function handlePrecheckoutSubmit(ev) {
  ev.preventDefault();

  var termsCheckbox = document.getElementById('terms_conditions');
  if (termsCheckbox && !termsCheckbox.checked) {
    var msgEl = document.getElementById('enova-message-carrito');
    if (msgEl) {
      msgEl.textContent = 'Debes aceptar los términos y condiciones';
      msgEl.classList.add('active');
    }
    return false;
  }

  var msgContainer = document.getElementById('enova-message-carrito');
  if (msgContainer) {
    msgContainer.classList.remove('active');
    msgContainer.innerHTML = '';
  }

  function getDocumentValue(typeDocument) {
    if (typeDocument === 'factura') {
      return document.querySelector('#enova-billing-doc-ruc') ? document.querySelector('#enova-billing-doc-ruc').value : '';
    } else {
      return document.querySelector('#enova-billing-documento-number') ? document.querySelector('#enova-billing-documento-number').value : '';
    }
  }

  var type_document = document.querySelector('input[name=enova-billing-doc]:checked')
    ? document.querySelector('input[name=enova-billing-doc]:checked').value
    : '';

  function getShippingMatch() {
    var addressSelected = document.querySelector('#enova-despacho-direccion') ? document.querySelector('#enova-despacho-direccion').value : '';
    return addressSelected;
  }

  var obj_params = {
    attributes: {
      pais: 'Peru',
      'Modalidad despacho': document.querySelector('input[name=enova-despacho]:checked') ? document.querySelector('input[name=enova-despacho]:checked').value : '',
      departamento: document.querySelector('#enova-carrito-block-despacho-shipping__departamento option:checked') ? document.querySelector('#enova-carrito-block-despacho-shipping__departamento option:checked').textContent.trim() : '',
      provincia: document.querySelector('#enova-carrito-block-despacho-shipping__provincia option:checked') ? document.querySelector('#enova-carrito-block-despacho-shipping__provincia option:checked').textContent.trim() : '',
      distrito: document.querySelector('#enova-carrito-block-despacho-shipping__distrito option:checked') ? document.querySelector('#enova-carrito-block-despacho-shipping__distrito option:checked').textContent.trim() : '',
      ubigeo: document.querySelector('#enova-carrito-block-despacho-shipping__distrito option:checked') ? document.querySelector('#enova-carrito-block-despacho-shipping__distrito option:checked').dataset.code : '',
      direccion: getShippingMatch(),
      referencia: document.querySelector('#enova-despacho-referencia') ? document.querySelector('#enova-despacho-referencia').value : '',
      'comprobante de pago': type_document,
      email: document.querySelector('#enova-billing-email') ? document.querySelector('#enova-billing-email').value : '',
      nombre: document.querySelector('#enova-billing-name') ? document.querySelector('#enova-billing-name').value : '',
      apellido: document.querySelector('#enova-billing-lastName') ? document.querySelector('#enova-billing-lastName').value : '',
      telefono: document.querySelector('#enova-billing-telefono') ? document.querySelector('#enova-billing-telefono').value : '',
      'Documento Identidad': document.querySelector('#enova-billing-documento-number') ? document.querySelector('#enova-billing-documento-number').value : ''
    }
  };

  if (document.querySelector('input[name=enova-despacho-tipo]:checked') &&
      document.querySelector('input[name=enova-despacho-tipo]:checked').value === 'programmed') {
    obj_params.attributes['fecha de envio'] = document.querySelector('#enova-despacho-delivery-select-fecha').value;
    obj_params.attributes['horario de recojo'] = document.querySelector('#enova-despacho-delivery-select-horario').value;
  }

  if (document.querySelector('input[name=enova-billing-doc]:checked') &&
      document.querySelector('input[name=enova-billing-doc]:checked').value === 'factura') {
    obj_params.attributes.ruc = document.querySelector('#enova-billing-doc-ruc').value;
    obj_params.attributes['razon social'] = document.querySelector('#enova-billing-doc-razonsocial').value;
  }

  if (document.querySelector('input[name=enova-despacho]:checked') &&
      document.querySelector('input[name=enova-despacho]:checked').value === 'delivery') {
    obj_params.attributes['tipo de envio'] = document.querySelector('input[name=enova-despacho-tipo]:checked')
      ? document.querySelector('input[name=enova-despacho-tipo]:checked').value
      : '';
  }

  if (document.querySelector('input[name=enova-despacho]:checked') &&
      document.querySelector('input[name=enova-despacho]:checked').value === 'recojo-tienda') {
    var tiendaInput = document.querySelector('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked');
    obj_params.attributes.departamento = tiendaInput ? tiendaInput.dataset.departamento : '';
    obj_params.attributes.provincia    = tiendaInput ? tiendaInput.dataset.provincia    : '';
    obj_params.attributes.distrito     = tiendaInput ? tiendaInput.dataset.distrito     : '';
    obj_params.attributes.ubigeo       = tiendaInput ? tiendaInput.dataset.ubigeo       : '';
    obj_params.attributes.direccion    = tiendaInput && jQuery(tiendaInput).parent().find('.enova-tienda-direccion').text()
      ? 'Recojo Tienda: ' + jQuery(tiendaInput).parent().find('.enova-tienda-direccion').text()
      : '';
    obj_params.attributes.referencia   = '-';
    obj_params.attributes['tienda recojo'] = tiendaInput ? jQuery(tiendaInput).parent().find('.enova-tienda-titulo').text() : '';
  }

  // ==========================================
  // VALIDACIÓN
  // ==========================================
  var formValid = true;
  var fieldsCommon   = ['nombre', 'apellido', 'email', 'telefono', 'Documento Identidad', 'pais', 'Modalidad despacho', 'comprobante de pago'];
  var fieldsDelivery = fieldsCommon.concat(['departamento', 'provincia', 'distrito', 'ubigeo', 'direccion', 'referencia', 'tipo de envio']);
  var fieldsPickup   = fieldsCommon.slice();

  var dispatchMode    = obj_params.attributes['Modalidad despacho'] || 'delivery';
  var fieldsToValidate = (dispatchMode === 'recojo-tienda') ? fieldsPickup : fieldsDelivery;

  var $inputPhone    = jQuery('#enova-billing-telefono');
  var $selectDocType = jQuery('#enova-billing-documento-type');
  var $inputDocNum   = jQuery('#enova-billing-documento-number');
  var $msgContainer  = jQuery('#enova-message-carrito');
  var $radioFactura  = jQuery('input[name="enova-billing-doc"]:checked');
  var $inputRucFact  = jQuery('#enova-billing-doc-ruc');

  $msgContainer.removeClass('active').text('');
  $inputDocNum.removeClass('input-has-error');
  jQuery('.text-has-error.text-typedoc').remove();

  fieldsToValidate.forEach(function(key) {
    var value = obj_params.attributes[key];
    if (!value || value.trim() === '') {
      formValid = false;
    }
  });

  if ($inputPhone.val().length < 9) formValid = false;

  var docType = $selectDocType.val();
  var docNum  = $inputDocNum.val();
  var docLen  = docNum.length;
  var docMessage = '';
  var isDocValid = true;

  if (docType === '1') {
    if (docLen !== 8 || isNaN(docNum)) { docMessage = 'El DNI debe tener 8 dígitos numéricos.'; isDocValid = false; }
  } else if (docType === '2') {
    var isAlphanumeric = /^[a-zA-Z0-9]+$/.test(docNum);
    if (docLen < 8 || docLen > 12 || !isAlphanumeric) { docMessage = 'El Carnet de Extranjería debe tener entre 8 y 12 caracteres.'; isDocValid = false; }
  } else if (docType === '3') {
    if (docLen !== 11 || isNaN(docNum)) { docMessage = 'El RUC debe tener 11 dígitos numéricos.'; isDocValid = false; }
  }

  if (!isDocValid) {
    formValid = false;
    $msgContainer.text(docMessage).addClass('active');
    $inputDocNum.addClass('input-has-error');
    $inputDocNum.parent().append('<p class="text-has-error text-typedoc">' + docMessage + '</p>');
  }

  if ($radioFactura.val() === 'factura' && ($inputRucFact.val().length !== 11 || isNaN($inputRucFact.val()))) {
    $inputRucFact.addClass('input-has-error');
    formValid = false;
  }

  // ==========================================
  // SUBMIT
  // ==========================================
  if (formValid) {
    document.getElementById('enova_cart-data-submit').setAttribute('aria-busy', 'true');
    checkoutButtonLoader(true);

    // Safety timeout: si la API no responde en 30s, libera el botón
    var _submitTimeout = setTimeout(function() {
      checkoutButtonLoader(false);
      var msgEl = document.getElementById('enova-message-carrito');
      if (msgEl) {
        msgEl.textContent = 'El servidor tardó demasiado en responder. Por favor vuelve a intentar.';
        msgEl.classList.add('active');
      }
    }, 30000);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(obj_params)
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      serviceCart2CheckoutStoreFrontAPI(obj_params)
        .then(function(result) {
          if (result && result.message && result.name === 'Error') {
            checkoutButtonLoader(false);
            throw result;
          }

          if (result && result.checkout && result.checkout.webUrl) {
            clearTimeout(_submitTimeout);
            checkoutButtonLoader(true);
            setLocalStorageCustomerData();
            window.location.href = result.checkout.webUrl;
          } else {
            throw result;
          }
        })
        .catch(function(err) {
          clearTimeout(_submitTimeout);
          checkoutButtonLoader(false);

          var message_output = '';
          try {
            var jsonErrorObject = typeof err.message === 'string' ? JSON.parse(err.message) : err;
            if (jsonErrorObject && jsonErrorObject[0] && jsonErrorObject[0].code === 'INVALID' && jsonErrorObject[0].message) {
              message_output = 'Alguno de los campos no son válidos: ' + jsonErrorObject[0].message;
            } else {
              message_output = 'No se pudo crear el pedido. Por favor vuelve a intentar.';
            }
          } catch(e) {
            message_output = 'No se pudo crear el pedido. Por favor vuelve a intentar.';
          }

          checkoutButtonLoader(false);
          var msgEl = document.getElementById('enova-message-carrito');
          if (msgEl) {
            msgEl.textContent = message_output;
            msgEl.classList.add('active');
          }
        });
    })
    .catch(function(error) {
      clearTimeout(_submitTimeout);
      console.error('CART Error:', error);
      checkoutButtonLoader(false);
      var msgEl = document.getElementById('enova-message-carrito');
      if (msgEl) {
        msgEl.textContent = 'No se pudo actualizar el carrito. Por favor vuelve a intentar.';
        msgEl.classList.add('active');
      }
    });

  } else {
    var attrs = obj_params.attributes;

    function markField(id, value) {
      var el = document.getElementById(id);
      if (!el) return;
      if (!value || value === '') {
        el.classList.add('input-has-error');
      } else {
        el.classList.remove('input-has-error');
      }
    }

    markField('enova-billing-email',            attrs.email);
    markField('enova-billing-name',             attrs.nombre);
    markField('enova-billing-lastName',         attrs.apellido);
    markField('enova-billing-telefono',         attrs.telefono);
    markField('enova-billing-documento-number', attrs['Documento Identidad']);

    if ($inputPhone.val().length < 9) {
      jQuery('#enova-billing-telefono').addClass('input-has-error');
      if (jQuery('.text-has-error.text-phone').length === 0) {
        jQuery('#enova-billing-telefono').parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
      }
    }

    if (dispatchMode === 'delivery') {
      markField('enova-despacho-direccion',  attrs.direccion);
      markField('enova-despacho-referencia', attrs.referencia);
    }

    if (!document.querySelector('input[name=enova-despacho]:checked')) {
      var despachoContainer = document.querySelector('.enova-carrito-block-seleccion-despacho__container');
      if (despachoContainer) {
        despachoContainer.classList.add('input-has-error');
        if (!despachoContainer.querySelector('.msg-error-not-selected-option')) {
          var errDiv = document.createElement('div');
          errDiv.className = 'msg-error-not-selected-option';
          errDiv.textContent = 'Debes seleccionar tu tipo de Despacho';
          despachoContainer.parentNode.appendChild(errDiv);
        }
      }
    }

    if (!document.querySelector('input[name=enova-billing-doc]:checked')) {
      var billingContainer = document.querySelector('.enova-carrito-boleta-factura .enova-carrito-block-seleccion-despacho__container');
      if (billingContainer) {
        billingContainer.classList.add('input-has-error');
        if (!billingContainer.querySelector('.msg-error-not-selected-option')) {
          var errDiv2 = document.createElement('div');
          errDiv2.className = 'msg-error-not-selected-option';
          errDiv2.textContent = 'Debes seleccionar tu tipo de comprobante';
          billingContainer.parentNode.appendChild(errDiv2);
        }
      }
    }

    document.getElementById('enova_cart-data-submit').setAttribute('aria-busy', 'false');

    var msgEl = document.getElementById('enova-message-carrito');
    if (msgEl) {
      msgEl.textContent = 'Debes completar las casillas faltantes en rojo';
      msgEl.classList.add('active');
    }
  }
}

/* ============================================
   API CART
   ============================================ */

async function getResponseCartItems(format) {
  var carritoItems = [];
  var responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
  var dataCart = await responseCart.json();

  for (var item of dataCart.items) {
    var varianIdEncoded64 = 'gid://shopify/ProductVariant/' + item.variant_id;
    function utf8_to_b64(str) {
      return window.btoa(unescape(encodeURIComponent(str)));
    }

    var getUbigeoSelected  = jQuery('#enova-carrito-block-despacho-shipping__distrito option:selected').data('ubigeo');
    var getShippingMethod  = jQuery('input[name=enova-despacho-tipo]:checked').val();
    var getDespacho        = jQuery('input[name=enova-despacho]:checked').val();

    var lineItemsToAdd = {
      variantId: utf8_to_b64(varianIdEncoded64),
      quantity: item.quantity,
      attributes: [
        { key: 'tipo de despacho',   value: getDespacho },
        { key: 'shipping method',    value: getShippingMethod },
        { key: 'ubigeo',             value: String(getUbigeoSelected) },
        { key: 'peso',               value: String(item.grams) },
        { key: 'sku',                value: String(item.sku) }
      ]
    };

    if (format) {
      lineItemsToAdd.requires_shipping = true;
    }

    carritoItems.push(lineItemsToAdd);
  }

  return carritoItems;
}

function isCarritoProductTypeShipping(cartList) {
  var isCarritoReadyForShipping = false;
  for (var product of cartList) {
    if (product.requires_shipping) {
      isCarritoReadyForShipping = true;
      break;
    }
  }
  if (cartList && cartList.length === 0) isCarritoReadyForShipping = true;
  return isCarritoReadyForShipping;
}

/* ============================================
   STOREFRONT API - CREAR CHECKOUT
   ============================================ */

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
  try {
    async function createCheckout(client, inputCheckout) {
      var inputData = {
        email: inputCheckout.email,
        lineItems: inputCheckout.lineItems,
        shippingAddress: inputCheckout.shippingAddress,
        customAttributes: inputCheckout.customAttributes
      };
      return await client.checkout.create(inputData);
    }

    function getCartAttributesFormatted(cartAttributes) {
      var checkoutattrs = [];
      for (var cartKey in cartAttributes.attributes) {
        checkoutattrs.push({ key: cartKey, value: cartAttributes.attributes[cartKey] });
      }
      return checkoutattrs;
    }

    function checkoutUpdateAddress(shippingAddress) {
      function getProvinceCorrelatives(province) {
        if (province === 'Lima' || province === 'LIMA') return 'PE-LIM';
        return province;
      }
      return {
        address1: shippingAddress.direccion,
        address2: shippingAddress.referencia,
        firstName: shippingAddress.nombre,
        lastName: shippingAddress.apellido,
        company: shippingAddress['comprobante de pago'] === 'factura' ? shippingAddress.ruc : shippingAddress['Documento Identidad'],
        phone: shippingAddress.telefono,
        country: shippingAddress.pais,
        province: getProvinceCorrelatives(shippingAddress.departamento),
        city: shippingAddress.provincia,
        zip: shippingAddress.distrito
      };
    }

    var client = ShopifyBuy.buildClient({
      domain: 'mpc-peru.myshopify.com',
      storefrontAccessToken: 'f7e3d0d43c03f2e98ec6181366ec11ed'
    });

    var carritoItemsList = await getResponseCartItems();
    var checkoutAtributesList = getCartAttributesFormatted(cartAttributes);
    var checkoutAddressParsed = checkoutUpdateAddress(cartAttributes.attributes);

    var inoutCheckout2Create = {
      email: cartAttributes.attributes.email,
      lineItems: carritoItemsList,
      shippingAddress: checkoutAddressParsed,
      customAttributes: checkoutAtributesList
    };

    var checkout = await createCheckout(client, inoutCheckout2Create);

    if (!(checkout && checkout.id && checkout.webUrl)) {
      throw new Error('error create checkout');
    }

    return { checkout: checkout };

  } catch (err) {
    console.error('Error Storefront API:', err);
    checkoutButtonLoader(false);
    var msgEl = document.getElementById('enova-message-carrito');
    if (msgEl) {
      msgEl.textContent = 'No se pudo crear el pedido. Por favor vuelve a intentar en unos minutos.';
      msgEl.classList.add('active');
    }
    return err;
  }
}

/* ============================================
   UBIGEOS - POBLAR SELECTORES
   ============================================ */

async function populate(scope, options) {
  try {
    var countrySelected      = options.country;
    var departamentoSelected = options.departament;
    var provinceSelected     = options.district;
    var urlBuilder = null;

    if (scope === 'departaments') {
      urlBuilder = '?scope=departaments&country=' + countrySelected;
    } else if (scope === 'provinces') {
      urlBuilder = '?scope=provinces&country=' + countrySelected + '&departament=' + departamentoSelected;
    } else if (scope === 'distrits') {
      urlBuilder = '?scope=distrits&country=' + countrySelected + '&departament=' + departamentoSelected + '&province=' + provinceSelected;
    }

    var response = await fetch(window.Shopify.routes.root + 'apps/apolo-ubigeo-calculation' + urlBuilder, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    var data = await response.json();

    return data.filter(function(item) {
      if ('is_active' in item) return item.is_active;
      return true;
    });

  } catch (err) {
    console.error('Error populate ubigeo:', err);
    return err;
  }
}

function setResetSelectorOptions(scope, addressBilling) {
  var templateList = '<option value="">Seleccione</option>';
  if (scope === 'departaments') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__departamento' : '#enova-carrito-block-despacho-shipping__departamento').html(templateList);
  } else if (scope === 'provinces') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__provincia' : '#enova-carrito-block-despacho-shipping__provincia').html(templateList);
  } else if (scope === 'distrits') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__distrito' : '#enova-carrito-block-despacho-shipping__distrito').html(templateList);
  }
}

function setSelectorOptions(scope, optionList, addressBilling) {
  var templateList = '<option>Seleccione...</option>';
  optionList.forEach(function(optionUbigeo) {
    templateList += '<option value="' + optionUbigeo.name + '" data-ubigeo="' + optionUbigeo.code + '" data-code="' + optionUbigeo.code + '" data-id="' + optionUbigeo.id + '">' + optionUbigeo.name + '</option>';
  });

  if (scope === 'departaments') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__departamento' : '#enova-carrito-block-despacho-shipping__departamento').html(templateList);
  } else if (scope === 'provinces') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__provincia' : '#enova-carrito-block-despacho-shipping__provincia').html(templateList);
  } else if (scope === 'distrits') {
    jQuery(addressBilling ? '#enova-carrito-block-despacho-billing__distrito' : '#enova-carrito-block-despacho-shipping__distrito').html(templateList);
  }
}

function initSetFormDataUbigeosAvailable() {
  setResetSelectorOptions('departaments');
  setResetSelectorOptions('provinces');
  setResetSelectorOptions('distrits');
  setResetSelectorOptions('departaments', true);
  setResetSelectorOptions('provinces', true);
  setResetSelectorOptions('distrits', true);

  populate('departaments', { country: '1', departament: null, district: null })
    .then(function(result) {
      setSelectorOptions('departaments', result);
      setSelectorOptions('departaments', result, true);

      var region = getCustomerData('region');
      if (region) {
        jQuery('#enova-carrito-block-despacho-shipping__departamento').val(region).change();
      }
    })
    .catch(function(err) { console.error('err ubigeo departaments', err); });

  jQuery('#enova-carrito-block-despacho-shipping__departamento').off('change').on('change', function() {
    setResetSelectorOptions('provinces');
    setResetSelectorOptions('distrits');

    var selectedID = jQuery('#enova-carrito-block-despacho-shipping__departamento option:selected').data('id');

    populate('provinces', { country: '1', departament: selectedID, district: null })
      .then(function(result) {
        setSelectorOptions('provinces', result);

        var city = getCustomerData('city');
        if (city && jQuery('#enova-carrito-block-despacho-shipping__departamento').val() === getCustomerData('region')) {
          jQuery('#enova-carrito-block-despacho-shipping__provincia').val(city).change();
        }
      })
      .catch(function(err) { console.error(err); });
  });

  jQuery('#enova-carrito-block-despacho-shipping__provincia').off('change').on('change', function() {
    setResetSelectorOptions('distrits');

    var selDeptID  = jQuery('#enova-carrito-block-despacho-shipping__departamento option:selected').data('id');
    var selProvID  = jQuery('#enova-carrito-block-despacho-shipping__provincia option:selected').data('id');

    populate('distrits', { country: '1', departament: selDeptID, district: selProvID })
      .then(function(result) {
        setSelectorOptions('distrits', result);

        var locality = getCustomerData('locality');
        if (locality && jQuery('#enova-carrito-block-despacho-shipping__provincia').val() === getCustomerData('city')) {
          jQuery('#enova-carrito-block-despacho-shipping__distrito').val(locality);
          document.querySelector('#enova-carrito-block-despacho-shipping__distrito').dispatchEvent(new Event('change', { bubbles: true }));

          var savedMethod = getCustomerData('shippingMethodType');
          if (savedMethod) {
            jQuery('input[name="enova-despacho-tipo"][value="' + savedMethod + '"]').prop('checked', true).trigger('change');
          }
        }
      })
      .catch(function(err) { console.error(err); });
  });

  jQuery('#enova-carrito-block-despacho-billing__departamento').off('change').on('change', function() {
    setResetSelectorOptions('provinces', true);
    setResetSelectorOptions('distrits', true);

    var selectedID = jQuery('#enova-carrito-block-despacho-billing__departamento option:selected').data('id');
    populate('provinces', { country: '1', departament: selectedID, district: null })
      .then(function(result) { setSelectorOptions('provinces', result, true); })
      .catch(function(err) { console.error(err); });
  });

  jQuery('#enova-carrito-block-despacho-billing__provincia').off('change').on('change', function() {
    setResetSelectorOptions('distrits', true);

    var selDeptID = jQuery('#enova-carrito-block-despacho-billing__departamento option:selected').data('id');
    var selProvID = jQuery('#enova-carrito-block-despacho-billing__provincia option:selected').data('id');
    populate('distrits', { country: '1', departament: selDeptID, district: selProvID })
      .then(function(result) { setSelectorOptions('distrits', result, true); })
      .catch(function(err) { console.error(err); });
  });

}

/* ============================================
   RENDER MÉTODOS DE ENVÍO
   ============================================ */

function SetRenderShippingMethodsListOption(methodsList) {
  var templateList = '';
  methodsList.forEach(function(method) {
    templateList += '<div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">' +
      '<input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-' + method.code + '" value="' + method.code + '">' +
      '<label for="enova-delivery-method-' + method.code + '" class="enova-shipping-tipo__delivery-label">' +
        '<div class="enova-shipping-method-tag-name-title">' +
          '<span class="enova-shipping-method-title">' + method.name + '</span>' +
          (method.price ? '<span class="enova-shipping-method-cost"> S/' + parseFloat(method.price).toFixed(2) + '</span>' : '') +
        '</div>' +
        '<div class="enova-shipping-method-tag-description"><p>' + (method.description || '') + '</p></div>' +
      '</label>' +
    '</div>';
  });

  jQuery('.enova-carrito-block-despacho-shipping-tipo__delivery--list').html(templateList);
}

/* ============================================
   VALIDACIÓN KEYPRESS
   ============================================ */

function setRenderCartFormKeypressValidation() {
  jQuery('#enova-billing-documento-type').off('change').on('change', function() {
    jQuery('#enova-billing-documento-number').val('');
    jQuery('p.text-has-error.text-typedoc').remove();
    document.querySelector('#enova-billing-documento-number').classList.remove('input-has-error');
  });

  jQuery('#enova-billing-documento-number').off('keypress').on('keypress', function(ev) {
    var input_doc_type_selected = jQuery('#enova-billing-documento-type').val();
    var currentLength = ev.currentTarget.value.length;
    var regex;

    if (input_doc_type_selected === '1') {
      regex = /^[0-9]$/;
      if (currentLength >= 8) { ev.preventDefault(); return; }
    } else if (input_doc_type_selected === '2') {
      regex = /^[a-zA-Z0-9]$/;
      if (currentLength >= 12) { ev.preventDefault(); return; }
    } else if (input_doc_type_selected === '3') {
      regex = /^[0-9]$/;
      if (currentLength >= 11) { ev.preventDefault(); return; }
    } else { return; }

    if (!regex.test(ev.key)) ev.preventDefault();
  });

  jQuery('#enova-billing-telefono').off('keypress').on('keypress', function(ev) {
    if (!/[0-9]/.test(ev.key)) ev.preventDefault();
  });

  jQuery('#enova-billing-doc-ruc').off('keypress').on('keypress', function(ev) {
    if (!/[0-9]/.test(ev.key)) ev.preventDefault();
  });
}

/* ============================================
   LOCAL STORAGE - DATOS DEL CLIENTE
   ============================================ */

var CUSTOMER_KEY = 'customerData';

function setCustomerData(field, value) {
  var data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
  data[field] = value;
  localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}

function getCustomerData(field) {
  var data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
  return data[field] || null;
}

function getAllCustomerData() {
  return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}

function setLocalStorageCustomerData() {
  setCustomerData('firstName',       jQuery('#enova-billing-name').val());
  setCustomerData('lastName',        jQuery('#enova-billing-lastName').val());
  setCustomerData('email',           jQuery('#enova-billing-email').val());
  setCustomerData('phone',           jQuery('#enova-billing-telefono').val());
  setCustomerData('documentType',    jQuery('#enova-billing-documento-type').val());
  setCustomerData('documentNumber',  jQuery('#enova-billing-documento-number').val());
  setCustomerData('shippingMethodType', jQuery('input[name="enova-despacho-tipo"]:checked').val());
  setCustomerData('shippingMethod',  jQuery('input[name="enova-despacho"]:checked').val());
  setCustomerData('region',          jQuery('#enova-carrito-block-despacho-shipping__departamento').val());
  setCustomerData('city',            jQuery('#enova-carrito-block-despacho-shipping__provincia').val());
  setCustomerData('locality',        jQuery('#enova-carrito-block-despacho-shipping__distrito').val());
  setCustomerData('address',         jQuery('#enova-despacho-direccion').val());
  setCustomerData('reference',       jQuery('#enova-despacho-referencia').val());
  setCustomerData('billingType',     jQuery('input[name="enova-billing-doc"]:checked').val());
  setCustomerData('ruc',             jQuery('#enova-billing-doc-ruc').val() || '');
  setCustomerData('companyName',     jQuery('#enova-billing-doc-razonsocial').val() || '');
}

function setInitCustomerData() {
  var customerData = getAllCustomerData();

  if (Object.keys(customerData).length === 0) {
    if (window.ShopifyCustomer && window.ShopifyCustomer.logged_in) {
      jQuery('#enova-billing-name').val(window.ShopifyCustomer.firstName);
      jQuery('#enova-billing-lastName').val(window.ShopifyCustomer.lastName);
      jQuery('#enova-billing-email').val(window.ShopifyCustomer.email);
    }
  } else {
    jQuery('#enova-billing-name').val(getCustomerData('firstName'));
    jQuery('#enova-billing-lastName').val(getCustomerData('lastName'));
    jQuery('#enova-billing-email').val(getCustomerData('email'));
    jQuery('#enova-billing-telefono').val(getCustomerData('phone'));
    jQuery('#enova-billing-documento-type').val(getCustomerData('documentType'));
    jQuery('#enova-billing-documento-number').val(getCustomerData('documentNumber'));

    // Restaurar tipo de despacho
    var savedShipping = getCustomerData('shippingMethod');
    if (savedShipping) {
      var shippingRadio = document.querySelector('input[name="enova-despacho"][value="' + savedShipping + '"]');
      if (shippingRadio) {
        shippingRadio.checked = true;

        document.querySelectorAll('.enova-despacho-selector-item').forEach(function(el) {
          el.classList.remove('active');
        });
        var parentLabel = shippingRadio.closest('.enova-despacho-selector-item');
        if (parentLabel) parentLabel.classList.add('active');

        if (savedShipping === 'delivery') {
          jQuery('#enova-despacho-shipping').css('display', 'block');
          jQuery('#enova-despacho-recojo-tienda').css('display', 'none');
          jQuery('#enova-despacho-direccion').val(getCustomerData('address'));
          jQuery('#enova-despacho-referencia').val(getCustomerData('reference'));
        } else if (savedShipping === 'recojo-tienda') {
          jQuery('#enova-despacho-shipping').css('display', 'none');
          jQuery('#enova-despacho-recojo-tienda').css('display', 'block');
        }
      }
    }

    // Restaurar tipo de comprobante
    var savedBilling = getCustomerData('billingType');
    if (savedBilling) {
      var billingRadio = document.querySelector('input[name="enova-billing-doc"][value="' + savedBilling + '"]');
      if (billingRadio) {
        billingRadio.checked = true;

        document.querySelectorAll('.enova-billing-item').forEach(function(el) {
          el.classList.remove('active');
        });
        var parentBilling = billingRadio.closest('.enova-billing-item');
        if (parentBilling) parentBilling.classList.add('active');

        var billingDocEl = document.querySelector('#enova-billing-doc');
        if (savedBilling === 'factura') {
          if (billingDocEl) {
            billingDocEl.classList.add('active');
            billingDocEl.classList.remove('disabled');
            billingDocEl.style.display = '';
          }
          jQuery('#enova-billing-doc-ruc').val(getCustomerData('ruc'));
          jQuery('#enova-billing-doc-razonsocial').val(getCustomerData('companyName'));
        } else if (savedBilling === 'boleta') {
          if (billingDocEl) {
            billingDocEl.classList.remove('active');
            billingDocEl.classList.add('disabled');
            billingDocEl.style.display = '';
          }
        }
      }
    }
  }
}

/* ============================================
   TIENDAS (RECOJO)
   ============================================ */

async function getPickUpShopList(filter_zona) {
  jQuery('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--list').html('<p>Validando...</p>');

  var response = await fetch(window.Shopify.routes.root + 'apps/apolo-ubigeo-calculation?scope=shop-addresses', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  });
  var data = await response.json();
  var shopsList = data.items;

  if (filter_zona) {
    shopsList = shopsList.filter(function(el) { return el.department === filter_zona; });
  }

  var templateBlockStoreList = '';
  shopsList.forEach(function(store) {
    templateBlockStoreList += '<label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-' + store.id + '">' +
      '<input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-' + store.id + '" data-departamento="' + store.department + '" data-provincia="' + store.province + '" data-distrito="' + store.distrit_name + '" data-ubigeo="' + store.ubigeo + '" />' +
      '<div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">' +
        '<h3 class="enova-tienda-titulo">' + store.name + '</h3>' +
        '<p class="enova-tienda-direccion">' + store.address + '</p>' +
      '</div>' +
    '</label>';
  });

  jQuery('.enova-carrito-block-despacho-recojo-tienda__list-tiendas--list').html(templateBlockStoreList);

  return shopsList;
}
